import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { formatSlugUpperCase } from "../../utils/slugify";
import Logo from "../../acade_logo1.png";
import "./TestInstructions.css";

export default function TestInstructions() {
  const navigate = useNavigate();
  const { slug, id } = useParams<{ slug: string; id: string }>();
  const [agreed, setAgreed] = useState(false);
  //const [lang, setLang] = useState("");
  const [username, setUsername] = useState("");

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (user) setUsername(user.firstname);
  }, []);

  const handleStart = () => {
    //if (!lang) return;
    navigate(`/online-tests/test-page/${slug}/${id}`);
  };

  const backPage = () => {
    navigate(-1); // ✅ Go back to previous page
  };

  return (
    <div className="test-page-container">
      {/* Header */}
      <div className="test-header">
        <div className="test-header-left">
          <Link to="/"><img src={Logo} alt="logo" /></Link> - {formatSlugUpperCase(slug || "")}
        </div>
        <div className="test-header-right">
          <button className="header-btn" onClick={backPage}>
            Back
          </button>
        </div>
      </div>

      {/* Instructions Content */}
      <div className="instructions-container">
        <div className="scrollable-content">
          <div className="instructions-box text-left">
            <h2 className="title">General Instructions</h2>

            <ol className="rules">
              <li>The Clock will be set at the server. The countdown timer at the top of screen will display the remaining time available for you to complete the examination. When the timer reaches zero, the exam will end by itself.</li>
              <li>The Question palette on the right shows the status of each question using symbols:
                <ul>
                  <li><span className="status-box not-visited"></span> Not Visited</li>
                  <li><span className="status-box not-answered"></span> Not Answered</li>
                  <li><span className="status-box answered"></span> Answered</li>
                  <li><span className="status-box marked"></span> Marked & Not Answered</li>
                  <li><span className="status-box marked-answered"></span> Marked & Answered</li>
                </ul>
              </li>
              <li>Each question clearly shows the <b>marks for a correct answer</b> and the <b>negative marking (if applicable)</b>.</li>
              <li>Each question has its <b>own timer</b> that records the time you spend on it.</li>
              <li>The test will open in <b>fullscreen mode</b>. You can press the fullscreen button again or the <kbd>Esc</kbd> key to exit fullscreen.</li>
              <li>You can use the <b>Pause button</b> to temporarily stop the test.  
                <ul>
                  <li>While paused, the timer stops and the screen is locked until you resume.</li>
                  <li>To exit the test midway, first click <b>Pause</b>, then click on the logo to return to the main page.</li>
                  <li><b>Note:</b> Pause option will not be available in <b>Live Tests</b> or <b>Contests</b>.</li>
                </ul>
              </li>
            </ol>

            <h4>Navigating to questions:</h4>
            <p>To answer the question, do the following:</p>
            <ul>
              <li>Click on the question number from the palette to go to that question.</li>
              <li>Click on <b>Save & Next</b> to save and move to the next question.</li>
              <li>Click on <b>Marked For Review & Next</b> to save, mark for review, and go to next question.</li>
              <li>Answers not saved will be lost when moving to another question.</li>
            </ul>

            {/* Language selector */}
            {/* <div className="form-group mt-3">
              <label>
                Choose your default language:
                <select value={lang} onChange={e => setLang(e.target.value)}>
                  <option value="">-- Select --</option>
                  <option value="1">English</option>
                  <option value="0">Hindi</option>
                </select>
              </label>
            </div> */}

            {/* Agreement */}
            <div className="form-check mt-2">
              <label>
                <input
                  type="checkbox"
                  checked={agreed}
                  onChange={() => setAgreed(!agreed)}
                />
                &nbsp;I have read the instructions and agree to the terms.
              </label>
            </div>
          </div>

          {/* Mobile Sidebar */}
          <div className="mobile-sidebar-instructions">
            <div className="user-section">
              <div className="avatar">👤</div>
              <span>{username}</span>
            </div>
            <hr />
          </div>
        </div>

        {/* Desktop Sidebar */}
        <div className="sidebar-instructions">
          <div className="user-section">
            <div className="avatar">👤</div>
            <span>{username}</span>
          </div>
          <hr />
        </div>
      </div>

      {/* Fixed Footer */}
      <div className="bottom-controls left-align">
        <button className="btn btn-secondary" onClick={backPage}>
          Back
        </button>
        <button
          className="btn-start"
          // disabled={!agreed || lang === ""}
          disabled={!agreed}
          onClick={handleStart}
        >
          I am ready to begin
        </button>
      </div>
    </div>
  );
}